<template>
<v-container class="fill-height data-container" fluid>
    <v-card>
        <v-card-title>Site Tag Edit</v-card-title>
        <v-divider />
        <v-card-text>
            <v-row dense>
                <v-col cols="12">
                    <v-text-field label="Site Tag Name" color="#c42111" v-model="$props.siteGroup.site_group_name" />
                </v-col>
                <v-col cols="12">
                    <v-textarea label="Site Tag Description" outlined color="#c42111" v-model="$props.siteGroup.site_group_desc" rows="3" />
                </v-col>
                <v-col cols="12">

                    <div class="edit-site-prompt-container" v-if="!editSites">
                        <v-btn class="prompt-button" color="#c42111" :disabled="!editSitesPermission" @click="enableEditSites">Apply Tag to Sites</v-btn>
                    </div>

                    <div class="data-table-container" v-if="editSites">
                        <v-data-table dense v-model="sitesWithTag" @input="inputChanged" :footer-props="footerProps" sort-desc :headers="siteListHeaders" :items="sitesList" item-key="site_id" sort-by="selected" 
                            :search="siteSearch" show-select :items-per-page="250" class="sites-table" height="calc(100vh - 580px)" fixed-header :loading="gettingSiteList" multi-sort @current-items="searchChange">
                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-toolbar-title style="font-weight: bold;">Sites Using Tag</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-text-field v-model="siteSearch" append-icon="mdi-magnify" color="#c42111" label="Site Search" single-line hide-details></v-text-field>
                                </v-toolbar>
                            </template>
                        </v-data-table>
                    </div>

                </v-col>
            </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
            <v-spacer />
            <v-btn text @click="cancelClick">Cancel</v-btn>
            <v-btn text @click="saveClick" :disabled="$props.lockSave">Save</v-btn>
        </v-card-actions>
    </v-card>

</v-container>
</template>

<script>
export default {
    name: 'SiteGroupEdit',
    props: ['siteGroup', 'lockSave'],
    components: {},
    data: () => ({
        editSites: false,
        editSitesPermission: false,
        gettingSiteList: false,

        sitesList: [],
        siteSearch: '',
        previousSiteSearch: '',
        siteListHeaders: [
            { text: ' ', align: 'start', sortable: true, value: 'selected' },
            { text: 'Name', align: 'start', sortable: true, value: 'site_name' },
            { text: 'Office', align: 'start', sortable: true, value: 'site_office' },
            { text: 'Location', align: 'start', sortable: true, value: 'site_location' },
            { text: 'Locale', align: 'start', sortable: true, value: 'site_locale' },
            { text: 'Technician', align: 'start', sortable: true, value: 'site_technician' },
        ],
        footerProps: {
            'items-per-page-options': [50, 100, 250, 500, 100, -1]
        },
        sitesWithTag: [],
        shiftKeyPressed: false,
        lastSelectedIndex: null,
        filteredItems: [],
    }),

    computed: {

    },

    methods: {
        enableEditSites: function() {
            let lockName = `edit_site`;
            this.$store.dispatch('getLock', lockName).then(lockOwner => {
                TELSA.loading(false);
                if(lockOwner) {
                    this.$store.commit('showConfirmModal', {
                        title: 'Lock Warning',
                        message: `The sites list is already locked for editing by <font color="#FB8C00"><b>${lockOwner}</b></font>. You cannot save any changes at this time.`,
                        type: 'warning',
                        hideCancel: true,
                        confirmAction: function(){}
                    });
                    return;
                }
                this.editSites = true;
                this.getSitesList();
            });
        },

        getSitesList: function() {
            this.gettingSiteList = true;
            let route = (TELSA.apiHost + "sitegroups/sitelist");
            return this.$http.post(route, {args: {siteGroup: this.$props.siteGroup}}).then(response => {
                let results = response.body;
                this.sitesList = results;
                this.sitesWithTag = results.filter(s => s.selected == 'yes');
                this.gettingSiteList = false;
            });
        },

        searchChange: function(filteredItems) {
            this.filteredItems = filteredItems;
            if(this.previousSiteSearch != this.siteSearch) {
                this.lastSelectedIndex = null;
            }
            this.previousSiteSearch = this.siteSearch;
        },

        cancelClick: function() {
            if(this.editSites) {
                this.clearSiteEdit();
                this.$store.dispatch('handleRemoveLocks', {});
            }
            this.$emit('cancel');
        },

        saveClick: function() {
            this.$emit('save', this.$props.siteGroup, this.editSites, this.sitesWithTag);
            if(this.editSites) {
                this.clearSiteEdit();
            }
        },

        clearSiteEdit: function() {
            this.sitesList = [];
            this.siteSearch = '';
            this.sitesWithTag = [];
            this.editSites = false;
        },

        inputChanged: function(selectedValues) {
            let newSelectedSitesIds = selectedValues.map(s => s.site_id);
            this.sitesList.forEach(site => {
                if(newSelectedSitesIds.includes(site.site_id)) {
                    site.selected = 'yes';
                }
                else {
                    site.selected = 'no';
                }
            });
            this.sitesWithTag = selectedValues;

        }
    },

    mounted() {
        this.editSitesPermission = TELSA.checkPermission(this.$store.state.user, 'admin/sites');
    }
};
</script>

<style scoped>

    .edit-site-prompt-container {
        height: calc(100vh - 435px) !important;
        position: relative;
        display: block;
        border: 1px solid #bcbcbc;
        border-radius: 4px;
        width: 100%;
        text-align: center;
    }
    .edit-site-prompt-container .prompt-button {
        position: relative;
        margin-top: calc(((100vh - 445px) / 2) - 30px);
    }

    .data-table-container .sites-table {
        border: 1px solid #bcbcbc;
        border-radius: 4px;
    }

</style>
